/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateUser = /* GraphQL */ `
  subscription OnCreateUser {
    onCreateUser {
      userId
      type
      name
      userPhotoPath
      firstName
      lastName
      email
      flowId
      stepId
      description
      birthDay
      address
      address2
      FaceId
      postalCode
      city
      gender
      extended
      createdAt
      updatedAt
      status
      tags
      group
      subgroups
      owner
      searchField
      flow
    }
  }
`;
export const onUpdateUser = /* GraphQL */ `
  subscription OnUpdateUser {
    onUpdateUser {
      userId
      type
      name
      userPhotoPath
      firstName
      lastName
      email
      flowId
      stepId
      description
      birthDay
      address
      address2
      FaceId
      postalCode
      city
      gender
      extended
      createdAt
      updatedAt
      status
      tags
      group
      subgroups
      owner
      searchField
      flow
    }
  }
`;
export const onCreateTemplate = /* GraphQL */ `
  subscription OnCreateTemplate {
    onCreateTemplate {
      id
      name
      description
      createdAt
      updatedAt
      schema
      status
      uischema
      document {
        nextToken
      }
      tags
      group
      subgroups
      owner
      html
      fileUrl
      searchField
      signaturesPositions {
        pageNumber
        rects
      }
    }
  }
`;
export const onUpdateTemplate = /* GraphQL */ `
  subscription OnUpdateTemplate {
    onUpdateTemplate {
      id
      name
      description
      createdAt
      updatedAt
      schema
      status
      uischema
      document {
        nextToken
      }
      tags
      group
      subgroups
      owner
      html
      fileUrl
      searchField
      signaturesPositions {
        pageNumber
        rects
      }
    }
  }
`;
export const onCreateDocument = /* GraphQL */ `
  subscription OnCreateDocument {
    onCreateDocument {
      id
      name
      description
      data
      status
      fileUrl
      type
      hash
      createdAt
      updatedAt
      template {
        id
        name
        description
        createdAt
        updatedAt
        schema
        status
        uischema
        tags
        group
        subgroups
        owner
        html
        fileUrl
        searchField
      }
      bundle {
        id
        name
        description
        status
        fileUrl
        fileUrlTemplate
        type
        createdAt
        updatedAt
        flowTemplateId
        tags
        flowId
        owner
        subgroups
        group
        searchField
        flow
      }
      tags
      flowId
      annexes {
        name
        path
        description
        skip
      }
      principal {
        name
        path
        description
        skip
      }
      owner
      subgroups
      html
      group
      searchField
      bundleId
      flow
      markAsRead
    }
  }
`;
export const onUpdateDocument = /* GraphQL */ `
  subscription OnUpdateDocument {
    onUpdateDocument {
      id
      name
      description
      data
      status
      fileUrl
      type
      hash
      createdAt
      updatedAt
      template {
        id
        name
        description
        createdAt
        updatedAt
        schema
        status
        uischema
        tags
        group
        subgroups
        owner
        html
        fileUrl
        searchField
      }
      bundle {
        id
        name
        description
        status
        fileUrl
        fileUrlTemplate
        type
        createdAt
        updatedAt
        flowTemplateId
        tags
        flowId
        owner
        subgroups
        group
        searchField
        flow
      }
      tags
      flowId
      annexes {
        name
        path
        description
        skip
      }
      principal {
        name
        path
        description
        skip
      }
      owner
      subgroups
      html
      group
      searchField
      bundleId
      flow
      markAsRead
    }
  }
`;
export const onCreateBundle = /* GraphQL */ `
  subscription OnCreateBundle {
    onCreateBundle {
      id
      name
      description
      status
      fileUrl
      fileUrlTemplate
      type
      createdAt
      updatedAt
      flowTemplateId
      template {
        id
        name
        description
        createdAt
        updatedAt
        schema
        status
        uischema
        tags
        group
        subgroups
        owner
        html
        fileUrl
        searchField
      }
      tags
      flowId
      owner
      subgroups
      group
      searchField
      document {
        nextToken
      }
      flow
    }
  }
`;
export const onUpdateBundle = /* GraphQL */ `
  subscription OnUpdateBundle {
    onUpdateBundle {
      id
      name
      description
      status
      fileUrl
      fileUrlTemplate
      type
      createdAt
      updatedAt
      flowTemplateId
      template {
        id
        name
        description
        createdAt
        updatedAt
        schema
        status
        uischema
        tags
        group
        subgroups
        owner
        html
        fileUrl
        searchField
      }
      tags
      flowId
      owner
      subgroups
      group
      searchField
      document {
        nextToken
      }
      flow
    }
  }
`;
export const onCreateNotification = /* GraphQL */ `
  subscription OnCreateNotification($group: String, $subgroups: [String]) {
    onCreateNotification(group: $group, subgroups: $subgroups) {
      id
      type
      data
      createdAt
      updatedAt
      visible
      read
      owner
      group
      subgroups
      code
    }
  }
`;
export const onUpdateNotification = /* GraphQL */ `
  subscription OnUpdateNotification {
    onUpdateNotification {
      id
      type
      data
      createdAt
      updatedAt
      visible
      read
      owner
      group
      subgroups
    }
  }
`;
